import { render } from "./StoreInfoManager.vue?vue&type=template&id=6c996220&scoped=true"
import script from "./StoreInfoManager.vue?vue&type=script&lang=js"
export * from "./StoreInfoManager.vue?vue&type=script&lang=js"

import "./StoreInfoManager.vue?vue&type=style&index=0&id=6c996220&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c996220"]])

export default __exports__